// import LoginPage from "./pages/Login/LoginPage";
// import AppRoutes from "./routes/AppRoutes";

// import { BrowserRouter } from "react-router-dom";

// function App() {
//   const token = localStorage.getItem("access");

//   return token ? (
//     <BrowserRouter>
//       <AppRoutes />
//     </BrowserRouter>
//   ) : (
//     <LoginPage />
//   );
// }

// export default App;
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./pages/Login/LoginPage";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const token = localStorage.getItem("access");

  useEffect(() => {
    // Show toast when token is missing (session expired case)
    if (!token) {
      const lastError = localStorage.getItem("lastAuthError");
      if (lastError === "401") {
        toast.error("Session expired. Please login again.", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
        });
        localStorage.removeItem("lastAuthError"); // clear flag
      }
    }
  }, [token]);

  return (
    <>
      <ToastContainer />
      {token ? (
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      ) : (
        <LoginPage />
      )}
    </>
  );
}

export default App;